import { useNavigate } from 'react-router-dom';
import { NonOrderableProductProps } from '../interface/interface';
import LoadingButton from './LoadingButton';
import ShopAllMedications from './ShopAllMedications';

export function NonOrderableProducts(props: NonOrderableProductProps) {
  const navigate = useNavigate();

  if (!props.data.length) return <></>;

  return props.data.map((product) => (
    <li
      className="col-span-1 flex flex-col rounded-lg border border-secondary-darkred-50 
    border-solid bg-white text-center shadow px-5 py-4 cursor-pointer relative h-full"
      key={product.id}
    >
      <div
        className="flex flex-1 flex-col justify-around"
        onClick={() =>
          navigate(`/product/${product.product_code}`, {
            state: {
              from: window.location.pathname,
              nonOrderable: true,
            },
          })
        }
      >
        <div className="flex justify-between text-sm 3xl:text-base font-bold text-secondary-cornflowerblue-600 capitalize">
          <p>{product.product_brand}</p>
          <p>${product.price}</p>
        </div>
        <div className="flex justify-between text-xs font-semibold text-grey-500 mb-1 uppercase items-center">
          <p className="text-left two-line-ellipsis relative">{product.name}</p>
          <p>
            {product.weight}
            {product.unit}
          </p>
        </div>
        <div className="h-44 w-full flex justify-center relative">
          <img
            className="rounded-lg h-44"
            src={product.image_url}
            alt="product-image"
            style={{ objectFit: 'contain' }}
            id={`product-image-${product.product_code}`}
          />
          <div className="w-full h-full flex z-10 absolute top-0 left-0 justify-center items-center bg-white opacity-50"></div>
          <div className="w-full h-full flex z-20 absolute top-0 left-0 justify-center items-center bg-transparent">
            <span className="text-black text-sm w-6/7 font-semibold text-center select-text italic">
              Please contact our team on 1800 123 687 to arrange access
            </span>
          </div>
        </div>
        <LoadingButton
          buttonText="Add to Cart"
          isLoading={false}
          buttonIcon={<>{'🛒'}</>}
          isDisabled={true}
        />
      </div>
      {props.enableShopAllMedications ? (
        <li className="bg-primary-blue-500 rounded-lg hidden lg:flex items-center justify-center">
          <ShopAllMedications className="flex flex-col items-center text-xl text-white font-semibold w-full h-full justify-center text-center" />
        </li>
      ) : null}
    </li>
  ));
}
